<template>
  <v-container>

    <Guide />

    <div id="page-heading" class="grey--text text-h5 text-sm-h4 text-md-h3 text-l-h2 text-xl-h2 mt-2">
      Content
    </div>

    <v-row flex>
      <v-col cols="6" v-for="subject in subjects" :key="subject.id">
        <Subject :subject="subject"></Subject>
      </v-col>

      <v-col cols="6">
        
        <v-card outlined>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialogVisible" max-width="500px" @click:outside="$refs.form.reset()">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="show-dialog"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="my-10 px-4"
                  x-large
                  depressed
                >
                  <v-icon large left class="mr-3">add</v-icon>
                  <span>Subject</span>
                </v-btn>
              </template>
              <v-card outlined>
                <v-form ref="form">
                  <v-card-title>
                    Add a new subject
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col cols="8">
                        <v-text-field 
                          id="title"
                          v-model="title"
                          label="Title"
                          :rules="[inputRules.required]"
                          autofocus                            
                          @keydown.enter="add">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn id="add-subject" depressed @click="add" :loading="submitting">Add</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Guide from '@/components/lecturer/Guide'
import Subject from './Subject'
import firebase from '@/firebase.config'

export default {
  name: "Content",
  components: { Guide, Subject },
  data: function () {
    return {
      dialogVisible: false,
      submitting: false,
      title: '',
      inputRules: {
        required: value => !!value || 'Required'
      }
    }
  },
  computed: {
    ...mapGetters({
      lecturer: "lecturer"
    }),
    subjects() {
      let subjects = []
      if (this.lecturer.subjects) {
        subjects = this.lecturer.subjects.filter(sub => sub.data.isArchived === false)
      }
      return subjects
    }
  },
  methods: {
    async add() {
      if (this.$refs.form.validate()) {
        this.submitting = true
        const subjectData = { 
          title: this.title,
          isArchived: false,
          parentPath: this.lecturer.path
        }
        await this.$store.dispatch('addSubject', subjectData)
        
        // Report to GA
        firebase.analytics().logEvent('add_subject')

        this.$refs.form.reset()
        this.submitting = false
        this.dialogVisible = false
      }
    }
  },
  mounted() {
    this.$vuetify.goTo('#page-heading', {
      duration: 1000,
      easing: 'easeInOutCubic'
    })
  }
}
</script>

<style scoped>
</style>
